import BgIconPrefix from "./BgIconPrefix";
import BgStandard from "./BgStandard";
import BtnArrowRight from "./BtnArrowRight";
import BtnViewMoreExpand from "./BtnViewMoreExpand";
import DiscoverMore from "./DiscoverMore";
import IconButton from "./IconButton";
import MenuItem from "./MenuItem";
import MenuPanelItem from "./MenuPanelItem";

const EXPORT = {
  BgIconPrefix,
  BgStandard,
  BtnArrowRight,
  BtnViewMoreExpand,
  DiscoverMore,
  IconButton,
  MenuItem,
  MenuPanelItem,
};

export default EXPORT;
